module.exports = __webpack_public_path__ + "img/6.6ac91941.png";